export default __webpack_public_path__ + "static/media/gaLogo.a966f008.png";